module.exports = __webpack_public_path__ + "Server-Disabled.AzureCloudService.24e70da290cae954ea3e8ad4d93faf7c.hashedasset.svg";